const generateAlias = (nodeName, nodeId) => {
  return nodeName.replace(/ /g, '_') + nodeId.substring(7);
};
export default generateAlias;
